import { track } from '../telemetry';

export const BROADCAST_CHANNEL_AUTH_ID = 'authenticationStatus';
export const BROADCAST_CHANNEL_CODE = {
  logout: 'logout',
  loginError: 'loginError',
  reload: 'reload',
  pinIn: 'pinIn',
};

export type PinInBroadcastPayload = {
  code: typeof BROADCAST_CHANNEL_CODE.pinIn;
  latestPinnedUserName: string;
  latestPinnedMemberId?: number;
  latestPinnedMemberType?: string;
  sourceTabId: string;
};

// Communicate auth state across tabs/iframes
const bcAuth = new BroadcastChannel(BROADCAST_CHANNEL_AUTH_ID);
bcAuth.onmessage = event => {
  console.log('utils.helpers.broadcast-channel.bcAuth onMessage:', event);
};

export function broadcastChannelLogout(bcInstance: BroadcastChannel) {
  bcInstance.postMessage(BROADCAST_CHANNEL_CODE.logout);
}

export function broadcastChannelLoginError(bcInstance: BroadcastChannel) {
  bcInstance.postMessage(BROADCAST_CHANNEL_CODE.loginError);
}

export function broadcastChannelReload(bcInstance: BroadcastChannel) {
  try {
    bcInstance.postMessage(BROADCAST_CHANNEL_CODE.reload);
  } catch (error) {
    track('BROADCAST_CHANNEL_RELOAD_ERROR', { error });
  }
}

export function broadcastChannelPinIn(
  bcInstance: BroadcastChannel,
  payload: Omit<PinInBroadcastPayload, 'code'>,
) {
  try {
    bcInstance.postMessage({
      code: BROADCAST_CHANNEL_CODE.pinIn,
      ...payload,
    } as PinInBroadcastPayload);
  } catch (error) {
    track('BROADCAST_CHANNEL_RELOAD_ERROR', { error });
  }
}
